import _ from 'lodash';
import { lsImageHelpers, lsApiService } from 'ls-vue-common';
import {
  InstantQuoteBushTrimmingConstants,
  QuoteLeafRemovalOptions,
  OrderServicesConstants,
} from 'ls-constants';

function createFormData({ formData, type }) {
  const data = new FormData();

  if (formData.locations) {
    const locationsConstantsDict = {
      bush_trimming: InstantQuoteBushTrimmingConstants,
      leaf_removal: OrderServicesConstants,
    };

    _.forEach(locationsConstantsDict[type].locationsByKey, (location, key) => {
      let selected = null;

      selected = _.includes(formData.locations, key);

      if (selected) {
        data.append(key, 1);
      } else {
        data.append(key, 0);
      }
    });
  }

  if (formData.details) {
    data.append('details', formData.details);
  }

  if (formData.instant_quote_suggestion_id) {
    data.append('instant_quote_suggestion_id', formData.instant_quote_suggestion_id);
  }

  if (formData.copy_images_from_existing_instant_quotable_id) {
    data.append(
      'copy_images_from_existing_instant_quotable_id',
      formData.copy_images_from_existing_instant_quotable_id
    );
  }

  if (formData.service_promo_id) {
    data.append('service_promo_id', formData.service_promo_id);
  }

  return data;
}

function addImages({ formData, data, type }) {
  const imagesWithMeta = lsImageHelpers.generateImagesWithMetaPayload({
    images: formData.images,
    tag: `instant_quote_${type}.request`,
    namePrefix: `Instant Quote ${_.startCase(type)} Request`,
  });

  _.forEach(imagesWithMeta, (imageAndMeta, idx) => {
    const { image, meta } = imageAndMeta;
    // need to include image obj with name, type, uri for file upload to work
    data.append(`images[${idx}]`, image);
    data.append(`images_meta[${idx}][tag]`, meta.tag);
    data.append(`images_meta[${idx}][title]`, meta.title);
  });
}

function formatQuotePayloadBushTrimming({ formData }) {
  const data = createFormData({ formData, type: 'bush_trimming' });
  addImages({ formData, data, type: 'bush_trimming' });

  data.append('bushes_0ft_5ft_count', formData.bushes_0ft_5ft_count);
  data.append('bushes_5ft_10ft_count', formData.bushes_5ft_10ft_count);
  data.append('bushes_over_10ft_count', formData.bushes_over_10ft_count);
  data.append('desired_trim_length', formData.desired_trim_length);
  const clippings = formData.desired_clippings_haulaway ? 1 : 0;
  data.append('desired_clippings_haulaway', clippings);

  if (formData.instant_quote_suggestion_id) {
    data.append('instant_quote_suggestion_id', formData.instant_quote_suggestion_id);
  }

  if (!_.isNil(formData.cycle)) {
    data.append('cycle', formData.cycle);
  }

  if (formData.copy_images_from_existing_instant_quotable_id) {
    data.append(
      'copy_images_from_existing_instant_quotable_id',
      formData.copy_images_from_existing_instant_quotable_id
    );
  }

  return data;
}

function formatQuotePayloadLeafRemoval({ formData }) {
  const data = createFormData({ formData, type: 'leaf_removal' });
  addImages({ formData, data, type: 'leaf_removal' });

  const desiredBedCleanup = formData.desired_bed_cleanup ? 1 : 0;
  data.append('desired_bed_cleanup', desiredBedCleanup);

  const haulAway = formData.desired_haulaway ? 1 : 0;
  data.append('desired_haulaway', haulAway);

  data.append('last_service', formData.last_service);

  if (formData.other_debris) {
    data.append('other_debris', formData.other_debris);
  }

  _.forEach(QuoteLeafRemovalOptions.debrisTypesIq, (type) => {
    let selected = null;

    if (formData.debrisTypes) {
      selected = _.includes(formData.debrisTypes, type.value);
    }

    if (selected) {
      data.append(type.value, 1);
    } else {
      data.append(type.value, 0);
    }
  });

  return data;
}

function formatQuotePayloadFlowerBedWeeding({ formData }) {
  const data = new FormData();
  addImages({ formData, data, type: 'flower_bed_weeding' });

  return lsApiService.formatFormDataPayload({ payload: formData, fData: data });
}

//eslint-disable-next-line import/prefer-default-export
export const lsInstantQuoteStoreHelpers = {
  formatQuotePayloadBushTrimming,
  formatQuotePayloadLeafRemoval,
  formatQuotePayloadFlowerBedWeeding,
};
